import React from 'react'
import { motion } from 'framer-motion'
import { CONFIG } from '../config/constants'

const Terms: React.FC = () => {
  return (
    <div className="section-padding">
      <div className="container max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Terms of Service
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300">
            Terms and conditions for using our services
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="card p-8 space-y-8"
        >
          <div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Acceptance of Terms</h2>
            <p className="text-gray-600 dark:text-gray-300">
              By accessing and using PhysioCare services, you accept and agree to be bound by the terms and provision of this agreement.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Services</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">PhysioCare provides physiotherapy services including but not limited to:</p>
            <ul className="list-disc list-inside space-y-2 text-gray-600 dark:text-gray-300">
              <li>Clinical physiotherapy treatment</li>
              <li>Home care services</li>
              <li>Tele-rehabilitation</li>
              <li>Exercise prescription</li>
              <li>Consultation services</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Appointments</h2>
            <p className="text-gray-600 dark:text-gray-300">
              Appointments must be scheduled in advance. Cancellations should be made at least 24 hours in advance to avoid cancellation fees.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Payment</h2>
            <p className="text-gray-600 dark:text-gray-300">
              Payment is due at the time of service unless other arrangements have been made. We accept cash, credit cards, and insurance.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Liability</h2>
            <p className="text-gray-600 dark:text-gray-300">
              PhysioCare is committed to providing high-quality care, but we cannot guarantee specific outcomes. Patients are responsible for following treatment plans and recommendations.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Privacy</h2>
            <p className="text-gray-600 dark:text-gray-300">
              We respect your privacy and are committed to protecting your personal information in accordance with our Privacy Policy.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Changes to Terms</h2>
            <p className="text-gray-600 dark:text-gray-300">
              We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Contact Information</h2>
            <p className="text-gray-600 dark:text-gray-300">
              For questions about these terms, please contact us at{' '}
              <a href={`mailto:${CONFIG.email}`} className="text-primary-600 dark:text-primary-400 hover:underline">
                {CONFIG.email}
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default Terms
